/* eslint object-curly-newline: */
import { connect } from 'react-redux';
import LineChartComponent from './../Components/LineChartComponent.jsx';
import {
  getPerformanceMetrics,
  getMetricsPageHighlights
} from './../reducers';
import { metricsJobIdTooltipFooter } from './../helpers/chart';

import { selectPerformanceJob } from './../actions';
import { colours } from './../helpers';
import { metrics as metricConstants } from './../helpers';

export const mapStateToProps = (state) => {
  const metrics = getPerformanceMetrics(state);
  const durationData = metrics.map(m => m && m.duration ? m.duration : 0);
  const maxDurationData = Math.max(...durationData);
  const minDurationData = Math.min(...durationData);
  const step = Math.round((maxDurationData - minDurationData) / durationData.length);
  const durationAvg = metricConstants.getRollingAverage(durationData, 0.10);
  const pointRadius = metrics ? 0 : 4;
  const highlights = getMetricsPageHighlights(state);

  return {
    data: [durationData, durationAvg],
    series: [
      {
        backgroundColor: colours.METRICS_CHARTS.CCF_DEFAULT,
        borderColor: colours.METRICS_CHARTS.CCF_DEFAULT,
        label: 'Duration',
        pointRadius
      },
      {
        backgroundColor: colours.METRICS_CHARTS.YELLOW,
        borderColor: colours.METRICS_CHARTS.YELLOW,
        label: 'Average Duration',
        pointRadius,
        borderWidth: 1
      },
    ],
    labels: metrics.map(m => m ? m.jobNumber : undefined),
    pointOptions: [{
      pointBackgroundColor: colours.METRICS_CHARTS.CCF_DEFAULT,
      pointRadius: 0
    }],
    orphanPointRadius: 4,
    lines: highlights,
    options: {
      scales: { xAxes: [{ offset: true }],
        yAxes: [{ ticks: { stepSize: step > 1 ? step : 1 }}] },
      tooltips: {
        callbacks: {
          footer: (tooltipItem) => metricsJobIdTooltipFooter(tooltipItem)(metrics)
        }
      }
    }
  };
};

export default connect(
  mapStateToProps,
  { onClick: selectPerformanceJob }
)(LineChartComponent);


// WEBPACK FOOTER //
// src/Containers/PerformanceMetricsDurationChartContainer.jsx